import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

interface GeocodeType {
  query: string;
  limit: number;
  match_type?: string;
}

interface GeocodeItemType {
  name: string;
  wgs84lat: number;
  wgs84lon: number
}

interface GeocodeResponseType {
  query: string;
  results: GeocodeItemType[]
}
const useGeocode = () => {
  return useMutation({
    mutationFn: async (
      query: GeocodeType
    ): Promise<GeocodeResponseType | null> => {
      if (!query) return null;

      const params = new URLSearchParams({ 
        ...query, 
        match_type: query.match_type || 'property_unit_designation' 
      }).toString();

      const URL = `${import.meta.env.VITE_API_GEOCODE_URL}?${params}`;

      const { data } = await axiosClient.get<GeocodeResponseType>(URL);

      return data;
    },
  });
};

export { useGeocode };
export type {GeocodeItemType, GeocodeResponseType, GeocodeType};
